import { DateConversionUtils } from '../../../../../utils/date-conversion-utils';
import { DateUtils } from '../../../../../utils/date-utils';
import { currentVbPlanYear } from '../../variable-benefit-accounts/utils/vb-annual-details-utils';

interface YearMonth {
  year: number;
  month: number;
}

export class VbRecurringPaymentProrationUtils {
  /**
   * Number of monthly payments left in the year the payments start. A start in a later year counts that whole
   * year, as the payment estimate does. Falls back to a full year when there is no start date.
   */
  public static remainingPaymentMonths(recurringPaymentStartDate: string | null | undefined): number {
    const start = DateConversionUtils.parseDateOnlyParts(recurringPaymentStartDate ?? '');
    return start && start.year <= currentVbPlanYear() ? 13 - start.month : 12;
  }

  /**
   * Number of monthly payments a configuration still makes this year: from the later of its start and this
   * month, up to the month before the configuration replacing it starts.
   */
  public static monthsLeftBeforeReplacement(
    recurringPaymentStartDate: string | null | undefined,
    replacementStartDate: string | null | undefined
  ): number {
    const today = DateConversionUtils.parseDateOnlyParts(DateUtils.todayInCST());
    if (!today) {
      return 0;
    }
    const thisMonth = VbRecurringPaymentProrationUtils.monthIndex(today);
    const start = DateConversionUtils.parseDateOnlyParts(recurringPaymentStartDate ?? '');
    const replacement = DateConversionUtils.parseDateOnlyParts(replacementStartDate ?? '');
    const firstMonth = start ? Math.max(VbRecurringPaymentProrationUtils.monthIndex(start), thisMonth) : thisMonth;
    const december = VbRecurringPaymentProrationUtils.monthIndex({ year: today.year, month: 12 });
    const lastMonth = replacement
      ? Math.min(december, VbRecurringPaymentProrationUtils.monthIndex(replacement) - 1)
      : december;
    return Math.max(0, lastMonth - firstMonth + 1);
  }

  private static monthIndex(date: YearMonth): number {
    return date.year * 12 + date.month - 1;
  }
}
